import { Injectable } from '@angular/core';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IzdatniceSirovinaService } from '../pages/izdatnice-sirovina/izdatnice-sirovina.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaRekapitulacijuIzdatnicaService {
  constructor(private service: IzdatniceSirovinaService, private authService: AuthService) {}

  pdfRekapitulacijaIzdatnica(
    dataStavkeIzdatnica,
    dataSkladisteNaziv,
    dataLinijaNaziv,
    dataDatumDo,
    dataDatumOd
  ) {
    //console.log('DATA OF STAVKE: ', dataStavkeIzdatnica);
    //console.log('DATA OF SKLADIŠE: ', dataSkladisteNaziv);
    //console.log('DATA OF LINIJA: ', dataLinijaNaziv);
    //console.log('DATA OF DATUM DO: ', dataDatumDo);
    //console.log('DATA OF DATUM OD: ', dataDatumOd);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];

    ct.push({
      columns: [
        {
          table: {
            widths: [200],
            heights: [85],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'SKLADIŠTE:  \n',
                          style: 'title',
                        },
                      ],
                      [
                        {
                          text: dataSkladisteNaziv,
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: dataLinijaNaziv,
                          style: 'subtitle',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },

        {
          table: {
            widths: [250],
            heights: [85],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'PEKAR d.o.o.',
                          style: 'title',
                        },
                      ],
                      [
                        {
                          text: 'Obrtnička 5',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Vinkovci',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Društvo upisano kod Trgovačkog suda u Osijeku MBS: 030084282, OIB: 67289965400. Temeljni kapital 5.384.400,00 kn; Predsjednik uprave: Bosiljko Stanić, direktor. Ž.r. Raiffeisen Bank 2484008-1106129914   IBAN: HR4024840081106129914 Ž.r. Otp bank 2407000-1100629330 IBAN: HR4024070001100629330 SWIFT: OTPVHR2X',
                          style: 'details',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },
      ],
    });

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
              [''],
              [''],
              [''],
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    ct.push({
      text: '\n' + '\n',
    });

    ct.push({
      text:
        'Rekapitulacija izdatnica od: ' +
        moment(dataDatumOd).format('DD.MM.YYYY. ') +
        'do ' +
        moment(dataDatumDo).format('DD.MM.YYYY.'),

      style: 'mainTitle',
      alignment: 'center',
      margin: [0, 0, 0, 0],
    });

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    let brojac = 1;
    let ukupnoVrijednost = 0;
    let arr = dataStavkeIzdatnica;
    let result = arr.reduce(function (r, a) {
      r[a.kolicina] = r[a.kolicina] || [];
      r[a.kolicina].push(a);
      return r;
    }, Object.create(null));
    // console.log(result);

    ct.push(hLine);
    ct.push({
      table: {
        widths: [20, 45, 165, 30, 60, 60, 60],
        body: [
          [
            { text: 'Rbr.' },
            { text: 'Šifra' },
            { text: 'Naziv artikla' },
            { text: 'Jed. mj.', alignment: 'center'},
            { text: 'Količina', alignment: 'right'},
            { text: 'Cijena', alignment: 'right'},
            { text: 'Vrijednost', alignment: 'right'},
          ],
        ],
      },
      layout: 'lightHorizontalLines',
      alignment: 'left',
    });

    ct.push(hLine);
    for (let lot in result) {
      let stavkaSifra = '';
      let stavkaNaziv = '';
      let stavkaJedinicaMjere = '';
      let stavkaKolicina = 0;
      let stavkaCijena = 0;
      let stavkaVrijednost = 0;

      for (let stavka of result[lot]) {
        stavkaSifra = stavka.ar_sifra;
        stavkaNaziv = stavka.ar_naziv;
        stavkaJedinicaMjere = stavka.jedinicamjere_JM_SIFRA;
        stavkaKolicina += stavka.kolicina;
        stavkaCijena = stavka.cijena;
        stavkaVrijednost += stavka.ukupno;
        ukupnoVrijednost += stavkaVrijednost;
      }

      ct.push({
        table: {
          widths: [20, 45, 165, 30, 60, 60, 60],
          body: [
            [
              { text: brojac++ },
              { text: stavkaSifra },
              { text: stavkaNaziv },
              { text: stavkaJedinicaMjere, alignment: 'center'},
              { text: this.formatiraj(stavkaKolicina, 3), alignment: 'right'},
              { text: this.formatiraj(stavkaCijena, 3), alignment: 'right'},
              { text: this.formatiraj(stavkaVrijednost, 2), alignment: 'right'},
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }

    //UKUPNO
    ct.push(hLine);
    ct.push({
      table: {
        widths: [470, 60],
        body: [
          [
            {
              text: 'UKUPNO',
              style: 'tableFooter',
              margin: [5, 0, 0, 0],
            },
            { text: this.formatiraj(ukupnoVrijednost, 2), style: 'tableFooter', alignment: 'right' },
          ],
        ],
      },
      layout: 'noBorders',
    });

    var dd = {
      info: {
        title: 'Rekapitulacija izdatnica: ',
      },
      content: ct,
      pageMargins: 20,
      defaultStyle: {
        fontSize: 7.5,
      },
      styles: {
        title: {
          fontSize: 12,
          bold: true,
        },
        subtitle: {
          fontSize: 10,
        },
        details: {
          fontSize: 6,
        },
        tableTitle: {
          fontSize: 8,
          bold: true,
        },
        mainTitle: {
          fontSize: 16,
          bold: true,
        },
        tableFooter: {
          bold: true,
        },
      },
    };

    pdfMake.createPdf(dd).open();
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }
}
